import { useEffect, useState } from 'react';
import { getAgeGroupProduct, getAgeGroupProductById } from '../services/AgeGroupProductService'

export const useAgeGroupProduct = () => {
    const [ageGroupProduct, setAgeGroupProduct] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchAgeGroupProduct = async () => {
        setLoading(true);
        try {
            const response = await getAgeGroupProduct();
            setAgeGroupProduct(response.data);
        } catch (err) {
            setError('Failed to fetch categories');
        } finally {
            setLoading(false);
        }
    };

    const fetchsetAgeGroupProductById = async (id) => {
        try {
            const response = await getAgeGroupProductById(id);
            setAgeGroupProduct(ageGroupProduct.map(p => (p.id === id ? response.data : p)));
        } catch {
            setError('Failed to update categories');
        }
    };

    useEffect(() => {
        fetchAgeGroupProduct();
    }, []);
    
    return {
        loading,
        error,
        ageGroupProduct,
        alert,
        fetchAgeGroupProduct,
        fetchsetAgeGroupProductById
    };
}